import { render } from "./VersionForm.vue?vue&type=template&id=b57fdb6e&scoped=true"
import script from "./VersionForm.vue?vue&type=script&lang=js"
export * from "./VersionForm.vue?vue&type=script&lang=js"

import "./VersionForm.vue?vue&type=style&index=0&id=b57fdb6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57fdb6e"]])

export default __exports__